import { render, staticRenderFns } from "./SendAs.vue?vue&type=template&id=05856344&scoped=true"
import script from "./SendAs.vue?vue&type=script&lang=js"
export * from "./SendAs.vue?vue&type=script&lang=js"
import style0 from "./SendAs.vue?vue&type=style&index=0&id=05856344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05856344",
  null
  
)

export default component.exports